<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-users"></i>
            </span>
            <h3 class="kt-portlet__head-title">สมาชิก</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="keyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อผู้ใช้งาน ชื่อบัญชี อีเมล เบอร์โทรศัพท์"
                  />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label>บทบาท:</label>
                  <!-- <select
                    id="roles"
                    name="roles"
                    multiple="multiple"
                    class="form-control m-select2"
                    style="width: 100%;"
                  ></select> -->
                  <treeselect
                    v-model="roles"
                    :multiple="true"
                    :options="rolesOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'inActiveStatus'"
                    :name="'inActiveStatus'"
                    :select2-options="inActiveStatusOptions"
                    v-model="inActiveStatus"
                    ref="inActiveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="Users/Add"
                  tag="button"
                  title="เพิ่มข้อมูลสมาชิก"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow('MASTER_USER')"
                >
                  <i class="fa fa-user-plus"></i> เพิ่มข้อมูลสมาชิก
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="userTable"
              >
                <thead>
                  <tr>
                    <th class="all">ชื่อผู้ใช้งาน (Username)</th>
                    <th class="all">อีเมล</th>
                    <th class="all">บทบาท</th>
                    <th class="all">ชื่อ - ชื่อสกุล</th>
                    <th class="all">โทรศัพท์</th>
                    <th class="all">ตำแหน่ง</th>
                    <th class="all">โปรไฟล์บริษัท</th>
                    <th class="all">วันที่เข้าใช้งานล่าสุด</th>
                    <th class="all">สถานะ</th>
                    <th class="all">คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>

    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let UserActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูลสมาชิก">
      <i class="la la-edit"></i>
    </a>
    <span class="dropdown" v-if="data.showEditButton && data.openId == false">
        <a href="#" class="btn btn-sm btn-clean btn-icon btn-icon-md" data-toggle="dropdown" aria-expanded="true" title="คำสั่งอื่นๆ">
          <i class="la la-ellipsis-h"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" href="#" @click.prevent="changePassword"><i class="la la-key"></i> แก้ไขรหัสผ่าน</a>
            <a class="dropdown-item" href="#" @click.prevent="forgotPassword"><i class="la la-envelope"></i> ส่งอีเมลรีเซ็ตรหัสผ่าน</a>
        </div>
    </span>
  </div>`,
  methods: {
    edit: function() {
      router.push({ path: `/Master/Users/Edit/${this.data.userName}` });
    },
    changePassword: function() {
      router.push({
        path: `/Master/Users/ChangePassword/${this.data.userName}`,
      });
    },
    forgotPassword: function() {
      Swal.fire({
        title: "ส่งอีเมลรีเซ็ตรหัสผ่าน",
        html:
          "ระบบจะส่งลิ้งค์สำหรับรีเซ็ตรหัสผ่านของ <strong>" +
          this.data.userName +
          "</strong> ไปยังอีเมลข้างล่างนี้",
        input: "text",
        inputValue: this.data.email,
        inputAttributes: {
          autocapitalize: "off",
          placeholder: "อีเมลที่ใช้รับลิ้งค์สำหรับรีเซ็ตรหัสผ่าน",
        },
        inputValidator: (value) => {
          if (!value) {
            return "กรุณากรอกอีเมลที่ใช้รับลิ้งค์สำหรับรีเซ็ตรหัสผ่าน";
          }

          var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!emailRegex.test(String(value).toLowerCase())) {
            return "คุณกรอกอีเมลไม่ถูกต้อง";
          }
        },
        showCancelButton: true,
        confirmButtonText: "ส่งอีเมล",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังส่งอีเมล กรุณารอสักครู่...",
          });

          axios
            .post("/Api/Users/ForgotPassword", {
              userName: this.data.userName,
              email: result.value,
            })
            .then(function(response) {
              if (response.data.status) {
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#userTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Users/" + this.data.userName + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#userTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Users/" + this.data.userName + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    return {
      keyword: "",
      status: -1,
      inActiveStatus: null,
      roles: [],
      rolesOptions: [],
      //Configurations
      inActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
    };
  },
  methods: {
    formReset: function(e) {
      this.keyword = "";
      this.status = -1;

      this.roles = [];

      //default Active Data
      this.inActiveStatus = false;
      $("#inActiveStatus")
        .val(this.inActiveStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#userTable").DataTable();
      table.search(this.keyword);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#userTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    LoadrolesOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Roles/Options", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rolesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    const user = await this.$root.getUser();
    var table = $("#userTable");

    self.LoadrolesOptions();

    //default Active Data
    self.inActiveStatus = false;
    $("#inActiveStatus")
      .val(self.inActiveStatus + "")
      .trigger("change");
      
    $.fn.dataTable.ext.errMode = 'none';
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,

        ajax: {
          url: "/Api/Users/Find",
          type: "post",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return $.extend({}, d, {
              roles: self.roles,
              inActiveStatus: $("#inActiveStatus").val(),
            });
          },
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
      <'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[6, "desc"]],

        columns: [
          { data: "userName" },
          { data: "email" },
          { data: "roles" },
          { data: "fullName" },
          { data: "phoneNumber", className: "text-center" },
          { data: "position", className: "text-center" },
          { data: "companyProfiles", width: "15%" },
          {
            data: "lastLogOnDateTime",
            className: "text-center",
            render: function(data, type, row, meta) {
              return row.lastLogOnDateTimeString;
            },
          },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "userName",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow("MASTER_USER");
            data.openId = data.openID;
            new UserActions({ data: { data } }).$mount(el);
          }
        });
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow(["MASTER_USER"]);
            if (data.inActiveStatus == 0)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
      });

    // $("#roles").select2({
    //   tags: true,
    //   placeholder: "เลือกบทบาท",
    //   allowClear: true,
    //   ajax: {
    //     url: "/Api/Roles/Options",
    //     data: function(params) {
    //       var query = {
    //         search: params.term,
    //         page: params.page || 1,
    //       };
    //       return query;
    //     },
    //     processResults: function(data, params) {
    //       return {
    //         results: data.results,
    //         pagination: {
    //           more: data.more,
    //         },
    //       };
    //     },
    //     transport: function(params, success, failure) {
    //       params.beforeSend = function(request) {
    //         request.setRequestHeader(
    //           "Authorization",
    //           "Bearer " + self.$root.user.access_token
    //         );
    //       };
    //       var $request = $.ajax(params);
    //       $request.then(success);
    //       $request.fail(failure);
    //       return $request;
    //     },
    //   },
    // });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/User/UserList.vue